import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true, timeout: 60000 });

let refreshing = null;
const refreshOnce = () => {
  if (!refreshing) refreshing = api.post("/auth/refresh").finally(() => { refreshing = null; });
  return refreshing;
};

api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config || {};
    if (err.response?.status === 401 && !cfg._retry && !cfg.url?.startsWith("/auth/")) {
      cfg._retry = true;
      try {
        await refreshOnce();
        return api(cfg);
      } catch (_) { /* fall through */ }
    }
    return Promise.reject(err);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!e?.response) return "Network problem. Please check your connection and try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg?.replace(/^Value error, /, "")).filter(Boolean).join(" ");
  return "Something went wrong. Please try again.";
}

export const aiStatus = () => api.get("/community/ai-status").then((r) => r.data.available === true).catch(() => false);

export const track = (event, props) => api.post("/events", { event, props }).catch(() => {});

// Server-sent events over POST (used by AI Coach).
export async function streamPost(path, body, onEvent) {
  const send = () => fetch(`${API}${path}`, { method: "POST", credentials: "include", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) });
  let res = await send();
  if (res.status === 401) {
    await refreshOnce();
    res = await send();
  }
  if (!res.ok) {
    let detail = "The coach is unavailable right now.";
    try { detail = (await res.json()).detail || detail; } catch (_) { /* ignore */ }
    throw new Error(typeof detail === "string" ? detail : "Request failed");
  }
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buf = "";
  for (;;) {
    const { done, value } = await reader.read();
    if (done) break;
    buf += decoder.decode(value, { stream: true });
    const parts = buf.split("\n\n");
    buf = parts.pop();
    parts.forEach((p) => {
      const line = p.trim();
      if (line.startsWith("data:")) {
        try { onEvent(JSON.parse(line.slice(5).trim())); } catch (_) { /* ignore */ }
      }
    });
  }
}
